module.exports = __webpack_public_path__ + "img/img_8.a7b3bb08.png";